export const HOSPITALIZATION_OPTIONS = {
  location: [
    {
      key: 'enfermaria',
      label: 'Enfermaria',
    },
    {
      key: 'semi',
      label: 'Semi-intensiva',
    },
    {
      key: 'uti',
      label: 'UTI',
    },
  ],
  reason: [
    {
      key: 'dermatite_atopica',
      label: 'Dermatite Atópica',
    },
    {
      key: 'infeccao_pele',
      label: 'Infecção de pele',
    },
    {
      key: 'infeccao_gu',
      label: 'Infecção GU',
    },
    {
      key: 'infeccao_dcv',
      label: 'Infecção, DCV',
    },
    {
      key: 'cirurgia_programada',
      label: 'Cirurgia Programada',
    },
    {
      key: 'erupcao_variceliforme',
      label: 'Erupção Variceliforme',
    },
    {
      key: 'eritrodermia_espoliativa',
      label: 'Eritrodermia Espoliativa',
    },
  ],
  other_events: [
    {
      key: 'iam',
      label: 'IAM',
    },
    {
      key: 'avc',
      label: 'AVC',
    },
    {
      key: 'tep',
      label: 'TEP',
    },
    {
      key: 'tvp',
      label: 'TVP',
    },
    {
      key: 'sepse',
      label: 'Sepse',
    },
    {
      key: 'ira',
      label: 'IRA',
    },
    {
      key: 'hepatite',
      label: 'Hepatite',
    },
    {
      key: 'meningite',
      label: 'Meningite',
    },
    {
      key: 'itu',
      label: 'ITU',
    },
    {
      key: 'erupcao_variceliforme',
      label: 'Erupção variceliforme',
    },
    {
      key: 'pielonefrite',
      label: 'Pielonefrite',
    },
  ],
}
